export const KYC_LINK_STATUS_POLLING_INTERVAL = 10000
export const KYC_LINK_READ_ONLY_POLLING_INTERVAL = 2000
export const KYC_STATUS_POLLING_INTERVAL = 4000
